import makeButton, { type ButtonContainerPropsBase } from "./Base/container";
import Component from "./component";

export default Component;

export type ButtonContainerProps = ButtonContainerPropsBase;
export { makeButton };
